import React, { useState, useEffect, forwardRef, useCallback, useMemo } from 'react';
import './HeaderWithBack.css';
import BackButton from '../BackButton/BackButton';

const HeaderWithBack: React.FC<{ title: string }> = ({ title }) => {
  const headerElement = useMemo(() => (
    <div className='header'>
      <BackButton />
      <h2>{ title }</h2>
    </div>
  ), []);

  return (
    <>
      { headerElement }
    </>
  );
};

export default HeaderWithBack;